<template>
   <div class="content-wrapper p-0">
      <app-overlay-loader v-if="preloader"/>
      <app-employee-latest
                :user="userInfo"
                :timeline-states="timelineStates">
        </app-employee-latest>
   </div>
</template>


<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin';
    import {UserMixin} from "../../../../../app/Components/Views/Auth/Mixins/UserMixin";
    import * as actions from '../../../../Config/ApiUrl';

    export default {
        name: "EmployeeDashboard",
        mixins: [FormMixin,UserMixin],
        watch: {
         userInfo: {
         immediate: true,
         handler (val, oldVal) {
               // If new file has been uploaded
               if(oldVal && val.candidate_id != null){
                  this.selectedId = val.candidate_id;
                  this.getCandidateByUserId();
               }
            }
         }
      },
        data() {
            return {
               preloader: true,
               finishedGetData: false,
               selectedId: 1,
               selectedSiteUrl: "",
               impersonate: true,
               timelineStates: [],
            }
        },
        created() {
            this.getTimelineStateNames();
        },
        methods: {
            /**
             * Get Additional Data
             * */
            getTimelineStateNames() {
                this.axiosGet('admin/app/timeline-states?status=3').then(response => {
                    if(response.data.length){
                        this.timelineStates = response.data;
                    } else {
                        this.timelineStates = response.data;
                    }

                    this.preloader = false;

                });
            },
            getCandidateByUserId() {
                if(this.selectedId){
                    // Get Candidate timeline_state by User Id
                    // Display available jobs and their onboarding sites
                    this.axiosGet('admin/app/candidates/'+this.selectedId).then(response => {
                        this.candidateOptions = response.data;

                    }).catch(({response}) => {
                    }).finally(() => {
                        let currentOnboardingSiteId = this.candidateOptions.timeline_state-6;
                        this.selectedSiteUrl = actions.SITE_ONBOARDING_DATA+'/'+currentOnboardingSiteId;
                        this.finishedGetData = true;
                    });
                
                }
            },
        }
    }
</script>
